const Contact = () => {
  return (
    <main className="os-main">
      <section
        className="os-home-card"
        style={{ maxWidth: 600, margin: '2rem auto' }}
      >
        <div className="text-center mb-4">
          <h2 className="os-title">Contact Me</h2>
          <p className="os-desc">I'd love to hear from you!</p>
          <hr
            className="hrStyle1"
            style={{ width: '60%', margin: '1rem auto' }}
          />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1.5rem',
          }}
        >
          <a
            href="mailto:jamesmcerniglia@gmail.com?subject=Reaching%20Out&body=Hi%20James%21%0A%0AI%20would%20love%20to%20get%20a%20chance%20to%20speak%20with%20you%21%0A"
            className="os-btn"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              fontSize: '1.1rem',
              width: 'fit-content',
            }}
          >
            <span role="img" aria-label="email">
              📧
            </span>
            jamesmcerniglia@gmail.com
          </a>
          <div
            className="os-btn"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.75rem',
              fontSize: '1.1rem',
              width: 'fit-content',
            }}
          >
            <span role="img" aria-label="location">
              📍
            </span>{' '}
            New York, NY
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
